export default "/images/e2a26cd6af8836d32ddb569e46043758.png";